import { chakra, forwardRef, ImageProps } from "@chakra-ui/react";
import logo from "assets/footerDisclaimerLogos/ICELogo.svg";

export const ICELogo = forwardRef<ImageProps, "img">((props, ref) => {
  return <chakra.img src={logo} ref={ref} {...props} />;
});
